import React from "react";
import { ChevronDown } from "../Icons";
import { useKnockFeed } from "../KnockFeedProvider";

var Dropdown = _ref => {
  var {
    children,
    value,
    onChange
  } = _ref;
  var {
    colorMode
  } = useKnockFeed();
  return /*#__PURE__*/React.createElement("div", {
    className: "rnf-dropdown rnf-dropdown--".concat(colorMode)
  }, /*#__PURE__*/React.createElement("select", {
    value: value,
    onChange: onChange
  }, children), /*#__PURE__*/React.createElement(ChevronDown, null));
};

export default Dropdown;
//# sourceMappingURL=Dropdown.js.map